import { isEmpty } from 'lodash';
import i18next from 'i18next';

export const getProductType = (product) => {
  if (product.childrenCashierProducts?.length > 0) {
    return i18next.t('ADMIN.PRODUCTS.PRODUCT_TYPE_MAIN');
  }

  if (product.parentCashierProducts?.length > 0 || !isEmpty(product.parentCashierProduct)) {
    return i18next.t('ADMIN.PRODUCTS.PRODUCT_TYPE_CHILD');
  }

  return '-';
};

/**
 * Determines if a cashier product should be disabled based on selection rules:
 * - If selected CPs have no parent and no children → all items remain selectable
 * - If selected CPs have a parent → disable CPs that have children
 * - If selected CPs have children → disable CPs that have a parent
 */
export const getIsNotSelectable = (cashierProduct, selectedCashierProducts) => {
  if (!selectedCashierProducts.length) {
    return false;
  }

  const { selectedHaveParent, selectedHaveChildren } = selectedCashierProducts.reduce(
    (acc, cp) => {
      if (!isEmpty(cp.parentCashierProduct)) {
        acc.selectedHaveParent = true;
      }
      if (cp.childrenCashierProducts?.length > 0) {
        acc.selectedHaveChildren = true;
      }
      return acc;
    },
    { selectedHaveParent: false, selectedHaveChildren: false },
  );

  // If no selected CP has parent or children, all items remain selectable
  if (!selectedHaveParent && !selectedHaveChildren) {
    return false;
  }

  const cpHasParent = !isEmpty(cashierProduct.parentCashierProduct);
  const cpHasChildren = cashierProduct.childrenCashierProducts?.length > 0;

  // If selected CPs have a parent, then disable CPs that have children
  if (selectedHaveParent && cpHasChildren) {
    return true;
  }

  // If selected CPs have children, then disable CPs that have a parent
  if (selectedHaveChildren && cpHasParent) {
    return true;
  }

  return false;
};
